var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgQsearchMenuIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 15,
  viewBox: "0 0 18 15",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.947368 0.5H17.0526C17.3597 0.5 17.5 0.709468 17.5 0.833333V5.83333C17.5 5.9572 17.3597 6.16667 17.0526 6.16667H0.947368C0.640277 6.16667 0.5 5.9572 0.5 5.83333V0.833333C0.5 0.709469 0.640277 0.5 0.947368 0.5ZM0.947368 8.83333H17.0526C17.3597 8.83333 17.5 9.0428 17.5 9.16667V14.1667C17.5 14.2905 17.3597 14.5 17.0526 14.5H0.947368C0.640278 14.5 0.5 14.2905 0.5 14.1667V9.16667C0.5 9.0428 0.640277 8.83333 0.947368 8.83333Z",
  stroke: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQsearchMenuIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/qsearch-menu-icon.53da929b.svg";
export { ForwardRef as ReactComponent };